// extracted by mini-css-extract-plugin
module.exports = {"container":"tvremote_container__3QbXU","body":"tvremote_body__X-gR2","bg-footer":"tvremote_bg-footer__3ecpv","image-bg":"tvremote_image-bg__3fDwD"};